import { InfoIcon } from '../assets/svgImages';

export const ErxStatusBanner = () => {
  return (
    <div
      className={
        'bg-primary-red-400 px-4 py-3 md:py-4 w-full flex justify-between items-center fixed z-10'
      }
    >
      <div className="flex items-center w-11/12 mx-auto">
        <InfoIcon className="w-6 hidden md:block fill-[#D15F9B]" />
        <p className="text-xs md:text-base text-white ml-3">
          <span className="font-semibold">
            The Government Electronic Prescription Service is currently
            experiencing a nation wide outage. Please try again later.{' '}
          </span>
          <span>
            For any help or support, feel free to reach out to our team at{' '}
            <a className="underline" href="tel:1800123687">
              1800 123 687
            </a>
          </span>
        </p>
      </div>
    </div>
  );
};
